<template>
    <div class="modal fade" id="editNotificationSettings" tabindex="-1" role="dialog"
         aria-labelledby="editNotificationSettingsModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="row" :style="{'disabled' : loading}">
                <div class="col-sm-12">
                    <div class="select-div pull-left">

                        <span v-if="!add_new">{{feed_name}}</span>
                        <select class="select-box sl-small" v-model="feed_id" @change="feedChanged" v-if="add_new">
                            <option value="-1" disabled>Select a Threat Type</option>
                            <option v-for="option in feeds" v-bind:value="option.id">{{ option.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-12" style="z-index: 2">
                    <div class="select-div pull-left" style="margin-top:10px">

                        <span v-if="!add_new">{{type_name}}</span>
                        <select class="select-box sl-small" v-model="type" @change="typeChanged" v-if="add_new">
                            <option value="-1" disabled>Select a Notification Type</option>
                            <option v-for="option in types" v-bind:value="option.id">{{ option.display_name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-5" v-if="!jira_selected">
                    <h4>Accounts</h4>
                    <select class="select-box" v-model="values_to_add" multiple>
                        <option v-for="option in available" v-bind:value="option.id"
                                :disabled="option.val == null || option.val == ''">{{ option.name + ": " + (option.val ?
                            option.val : "") }}
                        </option>
                    </select>
                </div>
                <div class="col-sm-2" style="margin-top: 135px;" v-if="!jira_selected">
                    <input class="select-button" type="button" @click="removeSelected()" value="&lt;"/>
                    <input class="select-button" type="button" @click="addSelected()" value="&gt;"/>
                </div>
                <div class="col-sm-5" v-if="!jira_selected">
                    <h4 style="margin-left: -15%;">Selected</h4>
                    <select class="select-box" v-model="values_to_remove" multiple style="margin-left: -15%;">
                        <option v-for="option in selected" v-bind:value="option.id">{{ option.name + ": " + (option.val
                            ? option.val : "") }}
                        </option>
                    </select>
                </div>
                <div class="col-sm-12" v-if="jira_selected">
                    <div style="width: 49%; display: inline-block; vertical-align: top; margin-top: 20px;">
                        <div class="jira-row-container">
                            <label class="jira-label">
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(0, $event)"
                                     @mouseout="onMouseOutTip()"/>
                                URL :</label>
                            <div class="jira-input">
                                <input id="jiraUrlInput" type="text" v-model="url"
                                       @keyup="testConnectionParamChanged(0)">
                                <label style="color:white">*</label>
                            </div>
                        </div>
                        <div class="jira-row-container">
                            <label class="jira-label">
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(1, $event)"
                                     @mouseout="onMouseOutTip()"/>
                                Username :</label>
                            <div class="jira-input">
                                <input id="jiraUsernameInput" type="text" v-model="username"
                                       @keyup="testConnectionParamChanged(0)">
                                <label style="color:white">*</label>
                            </div>
                        </div>
                        <div class="jira-row-container">
                            <label class="jira-label">
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(2, $event)"
                                     @mouseout="onMouseOutTip()"/>
                                Password :</label>
                            <div class="jira-input">
                                <input id="jiraPasswordInput" type="password" v-model="password"
                                       @keyup="testConnectionParamChanged(1)"/>
                                <label style="color:white">*</label>
                            </div>
                        </div>
                        <div class="jira-row-container">
                            <label class="jira-label">
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(3, $event)"
                                     @mouseout="onMouseOutTip()"/>
                                Project Key :</label>
                            <div class="jira-input">
                                <input id="jiraProjectInput" type="text" v-model="project_name"/>
                                <label style="color:white">**</label>
                            </div>
                        </div>
                        <div class="jira-row-container">
                            <label class="jira-label">
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(4, $event)"
                                     @mouseout="onMouseOutTip()"/>
                                Issue Type :</label>
                            <div class="jira-input">
                                <input id="jiraIssueInput" type="text" v-model="issue_type"/>
                                <label style="color:white">**</label>
                            </div>
                        </div>
                        <div class="jira-row-container">
                            <label class="jira-label">
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(5, $event)"
                                     @mouseout="onMouseOutTip()"/>
                                Summary :</label>
                            <div class="jira-input">
                                <input id="jiraSummaryInput" type="text" v-model="summary"/>
                                <label style="color:white">**</label>
                            </div>
                        </div>
                        <div class="jira-row-container">
                            <label class="jira-label">
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(6, $event)"
                                     @mouseout="onMouseOutTip()"/>
                                Priority :</label>
                            <div class="jira-input">
                                <input type="text" v-model="priority"/>
                            </div>
                        </div>
                        <div class="jira-row-container">
                            <label class="jira-label">
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(7, $event)"
                                     @mouseout="onMouseOutTip()"/>
                                Component :</label>
                            <div class="jira-input">
                                <input type="text" v-model="component"/>
                            </div>
                        </div>
                        <div class="jira-row-container">
                            <label class="jira-label">
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(8, $event)"
                                     @mouseout="onMouseOutTip()"/>
                                Assignee :</label>
                            <div class="jira-input">
                                <input type="text" v-model="assignee"/>
                            </div>
                        </div>
                        <div class="jira-row-container">
                            <label class="jira-label">
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(9, $event)"
                                     @mouseout="onMouseOutTip()"/>
                                Labels :</label>
                            <div class="jira-input">
                                <input type="text" v-model="labels"/>
                            </div>
                        </div>
                        <div class="jira-row-container">
                            <label class="jira-label">
                                <img width="15px"
                                     height="15px"
                                     class="main-item-question-mark"
                                     src="../../assets/question-mark-button.png"
                                     @mouseover="onMouseOverTip(10, $event)"
                                     @mouseout="onMouseOutTip()"/>
                                Description:</label>
                            <div class="jira-input">
                                <textarea rows="3" cols="50" v-model="description"></textarea>
                            </div>
                        </div>
                        <br>
                        <label class="jira-label" style="width: 100% !important;">(*) : Fields are required to test
                            connection.</label>
                        <label class="jira-label" style="width: 100% !important;">(**) : Fields are required to add Jira
                            notification.</label>
                        <br>
                        <br>
                        <div>
                            <button class="action-button notification-action-button grow" id="newJiraBtn"
                                    @click="newBtnClicked()">NEW
                            </button>
                            <button class="action-button notification-action-button grow" id="addJiraBtn"
                                    :disabled="!canAddJiraNotification()" @click="addBtnClicked()">ADD
                            </button>
                            <button class="action-button notification-action-button grow" id="testJiraBtn"
                                    @click="testBtnClicked()">TEST
                            </button>
                            <br>
                            <br>
                            <label id="jiraTestResponseLabel">{{jira_test_response}}</label>
                        </div>
                    </div><!--
                    -->
                    <div
                        style="width: 50%; display: inline-block; vertical-align: top; position: absolute; top: -40px; margin-left: 1%;">
                        <data-table class="jira-datatable" v-blur="blur"
                                    :clientPagination="true"
                                    :cols="jiraColumns"
                                    :url="jiraUrl"
                                    :orderBy="orderBy"
                                    :dataPath="dataPath"
                                    :requestParams="requestParams"
                                    @loading="onLoading"
                                    @loaded="onLoaded"
                                    @onEditClick="onJiraEditClick"
                                    @onDeleteClick="onJiraDeleteClick"
                                    :exportable="false"
                                    :isSummaryVisible="false"
                                    ref="jiraDatatable"></data-table>
                    </div>
                </div>
                <div class="col-sm-12 text-right" style="margin-top: 10px" v-if="!jira_selected">
                    <button class="action-button notification-action-button grow" @click="saveData()"
                            :disabled="!canSubmit()">SAVE
                    </button>
                </div>
                <div class="col-sm-12 text-right" style="margin-top: 10px" v-if="jira_selected">
                    <button class="action-button notification-action-button grow" @click="saveNotification()"
                            :disabled="!canSave()">SAVE
                    </button>
                </div>
            </div>
            <loading-modal v-if="loading"></loading-modal>
        </div>
        <confirm-popup-modal ref="confirmPopupModal" @okClicked="popUpConfirmClicked"
                             :modalName="'notificationSettingsModal'"/>
        <global-tooltip ref="jiraGlobalTooltip"></global-tooltip>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Constants from '@/utils/constants'
    import DataTable from '@/components/datatable/DataTable.vue'
    import ConfirmPopupModal from '@/components/modals/ConfirmPopupModal.vue'
    import LoadingModal from '@/components/modals/LoadingModal.vue'
    import GlobalTooltip from '@/components/tooltip/GlobalTooltip.vue'
    import Common from '@/utils/Common.vue'

    //POST
    const NOTIFICATIONS_DETAIL_POST = "/enterprise/notifications/detail";
    const NOTIFICATIONS_SAVE_POST = "/enterprise/notifications/save";
    const NOTIFICATION_TYPE_JIRA = 4;
    const NOTIFICATION_JIRA_ADD_POST = "/enterprise/notifications/jira/insert";
    const NOTIFICATION_JIRA_UPDATE_POST = "/enterprise/notifications/jira/update";
    const NOTIFICATION_JIRA_GET_POST = "/enterprise/notifications/jira/get";
    const NOTIFICATION_JIRA_DELETE_POST = "/enterprise/notifications/jira/delete";

    const JIRA_TOOLTIPS = [
        'Project url sample: https//comodo.atlassian.net',
        'Jira username',
        'Jira password',
        'Jira project key',
        'Issue types sample: Task,Bug,Story …',
        'Title of the ticket',
        'Issue Priority sample: Low,Lowest,Medium,High,Highest…',
        'User Defined components in Jira',
        'Assigned user name',
        'User Defined labels in Jira',
        'Issue description, (...) will be replaced with count of threats of selected threat type'
    ]

    const DEFAULT_PASSWORD = '********';
    const PARAM_TYPE_PASSWORD = 1;

    export default {
        name: "edit-notification-settings",
        components: {
            DataTable: DataTable,
            ConfirmPopupModal: ConfirmPopupModal,
            LoadingModal: LoadingModal,
            GlobalTooltip: GlobalTooltip
        },
        data() {
            return {
                feed_name_from_combobox: null,
                type_name_from_combobox: null,
                feed_name: "",
                type_name: "",
                add_new: false,
                url_data: null,
                types: [],
                feeds: [],
                available_types: [],
                available_feeds: [],
                values_to_remove: [],
                values_to_add: [],
                available: [],
                selected: [],
                type: -1,
                feed_id: -1,
                add_new: false,
                //JIRA PARAMS
                jira_selected: false,
                url: null,
                username: null,
                password: null,
                project_name: null,
                issue_type: null,
                summary: null,
                priority: null,
                component: null,
                assignee: null,
                labels: null,
                description: null,
                requestParams: {},
                loading: false,
                jiraConnectionSuccess: false,
                jiraInsertCompleted: false,
                jiraUpdateCompleted: false,
                deleteRequestData: {},
                jira_id: '',
                jira_pre_id: '',
                notification_id: null,
                messages: [],
                jira_test_response: '',
                notification_cat_logger_data: null,
                jira_notification_cat_logger_data: null,
                edited_jira_notification_cat_logger_data_url: null,
                edited_jira_notification_cat_logger_data_username: null,
                edited_jira_notification_cat_logger_data_threat_type: null,
                edited_notification_cat_logger_data: null,
                removeFromList: [],
                isEdit: false
            }
        },
        mixins: [Common],
        methods: {
            onMouseOverTip(index, e) {
                var rect = e.target.getBoundingClientRect();
                this.$refs.jiraGlobalTooltip.showTooltip(rect.top + 25, rect.left, JIRA_TOOLTIPS[index]);
            },
            onMouseOutTip() {
                this.$refs.jiraGlobalTooltip.hideTooltip();
            },
            onLoading() {
                //this.loading = true;
            },
            onLoaded() {
                this.loading = false;
            },
            showModal(data, add_new) {
                this.available_feeds = [];
                this.available_types = [];
                this.types = [];
                this.add_new = add_new;
                this.feeds = [];
                this.type = -1;
                this.feed_id = -1;
                this.values_to_remove = [];
                this.values_to_add = [];
                this.available = [];
                this.selected = [];
                this.url_data = {};
                this.add_new = add_new;
                this.clearJiraParams();

                $('#editNotificationSettings').modal('show');
                if (data != null && data.type == NOTIFICATION_TYPE_JIRA) {
                    this.notification_id = data.id;
                    this.jira_selected = true;
                    this.type = data.type;
                    this.feed_id = data.feed_enum;
                    this.feed_name = data.feed_name;
                    this.type_name = data.type_name;
                    this.loadJiraNotifications(data.id);
                } else {
                    if (add_new) {
                        this.url_data = {
                            type: this.type,
                            get_feeds: true
                        };
                    }
                    else {
                        this.url_data = {
                            id: data.feed_enum,
                            type: data.type
                        };
                        this.type = data.type;
                        this.type_name = data.type_name;
                        this.type_name_from_combobox = data.type_name;
                        this.feed_name = data.feed_name;
                        this.feed_id = data.feed_enum;
                        this.feed_name_from_combobox = data.feed_name;
                    }
                }
                this.loadData();
            },
            hideModal() {
                $('#editNotificationSettings').modal('hide');
            },
            clearJiraParams() {
                //JIRA PARAMS
                this.jira_selected = false;
                this.url = null;
                this.username = null;
                this.password = null;
                this.project_name = null;
                this.issue_type = null;
                this.summary = null;
                this.priority = null;
                this.component = null;
                this.assignee = null;
                this.labels = null;
                this.description = null;
                this.requestParams = {};
                this.loading = false;
                this.jiraConnectionSuccess = false;
                this.jiraInsertCompleted = false;
                this.jiraUpdateCompleted = false;
                this.deleteRequestData = {};
                this.jira_id = '';
                this.jira_pre_id = '';
                this.notification_id = null;
                this.jira_test_response = '';
            },
            removeSelected() {
                var self = this;
                this.values_to_remove.forEach(function (val) {
                    let i = self.getIndexByIdFromList(self.selected, val);
                    self.available.push(self.selected[i]);
                    self.selected.splice(i, 1)
                });
                this.removeFromList = self.available;
                this.values_to_remove = [];
                this.values_to_add = [];
            },
            addSelected() {
                var self = this;
                this.values_to_add.forEach(function (val) {
                    let i = self.getIndexByIdFromList(self.available, val);
                    self.selected.push(self.available[i]);
                    self.available.splice(i, 1)
                });
                this.values_to_remove = [];
                this.values_to_add = [];
            },
            getIndexByIdFromList(arr, val) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].id == val) {
                        return i;
                    }
                }
            },
            canAddJiraNotification() {
                return this.feed_id > 0 && this.jira_selected && this.jiraConnectionSuccess;
            },
            canSave() {
                return this.feed_id > 0 && this.jira_selected
                    && this.$refs.jiraDatatable != undefined
                    && this.$refs.jiraDatatable.tableData.length > 0;
            },
            canSubmit() {
                let can_submit = this.feed_id > 0 && this.type > 0;
                if (this.add_new)
                    return can_submit && this.selected.length > 0;
                else
                    return can_submit;
            },
            saveData() {
                let send_data = {
                    type: this.type,
                    type_name: this.type_name_from_combobox,
                    selected: this.selected,
                    feed_id: this.feed_id,
                    feed_name: this.feed_name_from_combobox
                };

                this.loading = true;
                this.notification_cat_logger_data = send_data;
                let promise = self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + NOTIFICATIONS_SAVE_POST, send_data);
                let recipient = '';
                let removeRecipient = '';
                promise.then(function (response) {
                    for (let i = 0; i < this.notification_cat_logger_data.selected.length; i++) {
                        if (this.notification_cat_logger_data.type_name === 'SMS' || this.notification_cat_logger_data.type_name === 'Telegram') {
                            if (i === this.notification_cat_logger_data.selected.length - 1) {
                                recipient = recipient + this.notification_cat_logger_data.selected[i].phone;
                            }
                            else {
                                recipient = recipient + this.notification_cat_logger_data.selected[i].phone + ',';
                            }
                        }
                        else if (this.notification_cat_logger_data.type_name === 'Email') {
                            if (i === this.notification_cat_logger_data.selected.length - 1) {
                                recipient = recipient + this.notification_cat_logger_data.selected[i].email;
                            }
                            else {
                                recipient = recipient + this.notification_cat_logger_data.selected[i].email + ',';
                            }
                        }
                    }

                    for (let j = 0; j < this.removeFromList.length; j++) {
                        if (this.notification_cat_logger_data.type_name === 'SMS' || this.notification_cat_logger_data.type_name === 'Telegram') {
                            if (j === this.notification_cat_logger_data.selected.length - 1) {
                                removeRecipient = removeRecipient + this.removeFromList[j].phone
                            }
                            else {
                                removeRecipient = removeRecipient + this.removeFromList[j].phone + ',';
                            }
                        }
                        else if (this.notification_cat_logger_data.type_name === 'Email') {
                            if (j === this.notification_cat_logger_data.selected.length - 1) {
                                removeRecipient = removeRecipient + this.removeFromList[j].phone
                            }
                            else {
                                removeRecipient = removeRecipient + this.removeFromList[j].phone + ',';
                            }
                        }
                    }
                    this.notification_cat_logger_data.first_recipient = '';
                    this.notification_cat_logger_data.recipient = recipient;
                    this.notification_cat_logger_data.remove_recipient = removeRecipient;
                    this.notification_cat_logger_data.customer_id = this.getEnterpriseId;
                    this.notification_cat_logger_data.customer_name = this.getEnterpriseName;
                    if (this.notification_cat_logger_data.selected.length > 0) {
                        if (this.notification_cat_logger_data.type_name === 'SMS' || this.notification_cat_logger_data.type_name === 'Telegram') {
                            this.notification_cat_logger_data.first_recipient = this.notification_cat_logger_data.selected[0].phone;
                        }
                        else if (this.notification_cat_logger_data.type_name === 'Email') {
                            this.notification_cat_logger_data.first_recipient = this.notification_cat_logger_data.selected[0].email;
                        }
                    }
                    if(this.isEdit) {
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_edit_notification_cat_logger, this.notification_cat_logger_data);
                    }
                    else {
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_add_notification_cat_logger, this.notification_cat_logger_data);
                    }
                    this.loading = false;
                    this.$emit("operationCompleted", {success: true, msg: ""});
                    self.hideModal();
                }, function () {
                    this.loading = false;
                    this.$emit("operationCompleted", {
                        success: false,
                        msg: "Error occurred when saving new notification"
                    });
                    self.hideModal();
                });
            },
            saveNotification() {
                if (this.notification_id == null) {
                    let send_data = {
                        type: this.type,
                        type_name: this.type_name_from_combobox,
                        selected: null,
                        feed_id: this.feed_id,
                        feed_name: this.feed_name_from_combobox

                    };
                    this.loading = true;
                    let promise = self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + NOTIFICATIONS_SAVE_POST, send_data);
                    promise.then(function (response) {
                        this.loading = false;
                        this.saveJiraNotificationData(response.body.data.notification_id);
                    }, function () {
                        this.loading = false;
                        // console.log("Error occurred when saving new notification");
                    });
                } else {
                    this.saveJiraNotificationData(this.notification_id);
                }
            },
            saveJiraNotificationData(notification_id) {
                var updateList = [];
                var insertList = [];
                var tableData = this.$refs.jiraDatatable.tableData;
                for (var i = 0; i < tableData.length; i++) {
                    if (tableData[i]['id'] != null) {
                        updateList.push(tableData[i]);
                    } else {
                        insertList.push(tableData[i]);
                    }
                }
                if (insertList.length > 0) {
                    this.jiraNotificationRequest(NOTIFICATION_JIRA_ADD_POST, notification_id, insertList);
                } else {
                    this.jiraInsertCompleted = true;
                }
                if (updateList.length > 0) {
                    this.jiraNotificationRequest(NOTIFICATION_JIRA_UPDATE_POST, notification_id, updateList);
                } else {
                    this.jiraUpdateCompleted = true;
                }
            },
            jiraNotificationRequest(requestPath, notification_id, dataList) {
                let send_data = {
                    notification_id: notification_id,
                    notifications: dataList
                };
                this.jira_notification_cat_logger_data = send_data;
                this.loading = true;
                let promise = self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + requestPath, send_data);
                promise.then(function (response) {
                    if (requestPath === NOTIFICATION_JIRA_ADD_POST) {
                        let cat_logger_data = {
                            feed_name: this.feed_name_from_combobox,
                            type: this.type,
                            type_name: 'JIRA',
                        };
                        cat_logger_data.recipient = this.jira_notification_cat_logger_data.notifications[0].url + ',' + this.jira_notification_cat_logger_data.notifications[0].username;
                        cat_logger_data.customer_id = this.getEnterpriseId;
                        cat_logger_data.customer_name = this.getEnterpriseName;
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_add_notification_cat_logger, cat_logger_data);
                    }
                    else {
                        let cat_logger_edit = {
                            feed_name: this.edited_jira_notification_cat_logger_data_threat_type,
                            type: this.type,
                            type_name: 'JIRA',
                        };
                        cat_logger_edit.recipient = this.jira_notification_cat_logger_data.notifications[0].url + ',' + this.jira_notification_cat_logger_data.notifications[0].username;
                        cat_logger_edit.customer_id = this.getEnterpriseId;
                        cat_logger_edit.customer_name = this.getEnterpriseName;
                        cat_logger_edit.remove_recipient = this.jira_notification_cat_logger_data.notifications[0].url + ',' + this.jira_notification_cat_logger_data.notifications[0].username;
                        cat_logger_edit.first_recipient = this.edited_jira_notification_cat_logger_data_url + ',' + this.edited_jira_notification_cat_logger_data_username;
                        this.saveCatLog(this, Constants.cat_logger.customer_ui_edit_notification_cat_logger, cat_logger_edit);
                    }
                    this.loading = false;
                    this.checkJiraSaveCompleted(requestPath);
                }, function () {
                    this.loading = false;
                    // console.log("Error occurred when saving new jira notification");
                    this.checkJiraSaveCompleted(requestPath);
                });
            },
            checkJiraSaveCompleted(type) {
                if (type == NOTIFICATION_JIRA_ADD_POST) {
                    this.jiraInsertCompleted = true;
                } else if (type == NOTIFICATION_JIRA_UPDATE_POST) {
                    this.jiraUpdateCompleted = true;
                }

                if (this.jiraInsertCompleted && this.jiraUpdateCompleted) {
                    this.$emit("operationCompleted", {success: true, msg: ""});
                    self.hideModal();
                }
            },
            loadJiraNotifications(notification_id) {
                self = this;
                var body = {
                    notification_id: notification_id
                }
                this.loading = true;
                var promise = self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + NOTIFICATION_JIRA_GET_POST, body);
                promise.then(function (response) {
                    this.loading = false;
                    // console.log(response.body);
                    self.$refs.jiraDatatable.tableData = [];
                    var tableData = response.data.data;
                    for (var i = 0; i < tableData.length; i++) {
                        tableData[i].password_changed = false;
                        self.$refs.jiraDatatable.tableData.push(tableData[i]).draw;
                    }
                }, function () {
                    this.loading = false;
                    this.$emit("operationCompleted", {success: false, msg: "Unable to retrieve notification details"});
                    self.hideModal();
                });
            },
            loadData() {
                self = this;
                this.loading = true;
                var promise = self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + NOTIFICATIONS_DETAIL_POST, self.url_data);
                promise.then(function (response) {
                    this.loading = false;
                    // console.log(response.body);
                    this.edited_notification_cat_logger_data = response.body.data.selected;
                    var available = response.body.data.available,
                        selected = response.body.data.selected;
                    if ( response.body.data.n_type === -1) {
                        this.isEdit = false;
                    }
                    else {
                        this.isEdit = true;
                    }
                    this.types = response.body.data.available_types;

                    //sort the feed
                    response.body.data.available_feeds.sort(function (a, b) {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                    });
                    this.feeds = response.body.data.available_feeds;

                    //Clone json lists
                    this.available_types = JSON.parse(JSON.stringify(response.body.data.available_types));
                    this.available_feeds = JSON.parse(JSON.stringify(response.body.data.available_feeds));

                    self.updateValByType(self.url_data.type, available);
                    self.updateValByType(self.url_data.type, selected);

                    this.available = available;
                    this.selected = selected;

                    this.messages = response.body.data.messages;

                    if (this.type == NOTIFICATION_TYPE_JIRA) {
                        this.changeJiraParams();
                    }

                }, function () {
                    this.loading = false;
                    this.$emit("operationCompleted", {success: false, msg: "Unable to retrieve notification details"});
                    self.hideModal();
                });
            },
            typeChanged() {
                for (let i = 0; i < this.types.length; i++) {
                    if (this.types[i].id == this.type) {
                        this.type_name_from_combobox = this.types[i].display_name;
                    }
                }
                if (this.type == NOTIFICATION_TYPE_JIRA) {
                    this.jira_selected = true;
                    this.changeJiraParams();
                } else {
                    this.jira_selected = false;
                }

                this.updateValByType(this.type, this.available);
                this.updateValByType(this.type, this.selected);
                this.refreshUsers();

            },
            feedChanged() {
                for (let i = 0; i < this.feeds.length; i++) {
                    if (this.feeds[i].id == this.feed_id) {
                        this.feed_name_from_combobox = this.feeds[i].name;
                    }
                }
                this.refreshTypes();
                this.refreshUsers();
                if (this.type == NOTIFICATION_TYPE_JIRA) {
                    this.jira_selected = true;
                    this.changeJiraParams();
                }
            },
            changeJiraParams() {
                if (this.feed_id > 0 && this.feed_id < 11) {
                    this.description = '(...) ' + this.messages[this.feed_id - 1].value;
                } else if (this.feed_id > 11) {
                    this.description = '(...) ' + this.messages[this.feed_id - 2].value;
                } else {
                    this.description = '';
                }

                if (this.feeds != null && this.feeds.length > 0) {
                    this.summary = this.feeds[this.feed_id - 1].name;
                } else {
                    this.summary = this.feed_name;
                }

            },
            refreshTypes() {
                let selected_feed = null;
                let self = this;

                this.available_feeds.forEach(function (feed_dict) {
                    if (feed_dict.id == self.feed_id) {
                        selected_feed = feed_dict;
                    }
                });

                if (selected_feed) {
                    this.types = [];
                    let new_types = [];
                    // Set available types by selected feed
                    this.available_types.forEach(function (type_dict) {
                        if (selected_feed.types.indexOf(type_dict.id) != -1) {
                            // console.log(selected_feed);
                            self.types.push(type_dict);
                            new_types.push(type_dict.id);
                        }
                    });

                    if (new_types.indexOf(this.type) == -1) {
                        this.type = -1;
                        this.updateValByType(this.type, this.available);
                        this.updateValByType(this.type, this.selected);
                    }
                }
            },
            refreshUsers() {
                let self = this;
                this.selected.forEach(function (user_dict) {
                    self.available.push(user_dict);
                });
                this.selected = [];
                this.values_to_add = [];
            },
            updateValByType(type, json_list) {
                let display_field = null;
                this.available_types.forEach(function (type_dict) {
                    if (type_dict.id == type) {
                        display_field = type_dict.field_name;
                    }
                });

                for (let i = 0; i < json_list.length; i++) {
                    if (display_field) {
                        json_list[i].val = json_list[i][display_field];
                    }
                    else {
                        json_list[i].val = null;
                    }
                }

            },
            testConnectionParamChanged(type) {
                this.jiraConnectionSuccess = false;
                var index = this.findElementIndexInTableData();
                if (type == PARAM_TYPE_PASSWORD && index > -1 &&
                    !this.$refs.jiraDatatable.tableData[index].password_changed
                    && $('#addJiraBtn').text() == 'UPDATE') {
                    this.$refs.jiraDatatable.tableData[index].password_changed = true;
                    if (this.password.length < DEFAULT_PASSWORD.length) {
                        this.password = '';
                    } else {
                        this.password = this.password[this.password.length - 1];
                    }
                }
            },
            checkJiraTestParams() {
                var response = true;
                if (this.url == undefined || this.url == null || this.url == "") {
                    response = false;
                    $("#jiraUrlInput").css("border-color", "red");
                } else {
                    $("#jiraUrlInput").css("border-color", "transparent");
                }
                if (this.username == undefined || this.username == null || this.username == "") {
                    response = false;
                    $("#jiraUsernameInput").css("border-color", "red");
                } else {
                    $("#jiraUsernameInput").css("border-color", "transparent");
                }
                if (this.password == undefined || this.password == null || this.password == "") {
                    response = false;
                    $("#jiraPasswordInput").css("border-color", "red");
                } else {
                    $("#jiraPasswordInput").css("border-color", "transparent");
                }

                return response;
            },
            checkJiraAddParams() {
                var response = true;

                if (this.url == undefined || this.url == null || this.url == "") {
                    response = false;
                    $("#jiraUrlInput").css("border-color", "red");
                } else {
                    $("#jiraUrlInput").css("border-color", "transparent");
                }
                if (this.username == undefined || this.username == null || this.username == "") {
                    response = false;
                    $("#jiraUsernameInput").css("border-color", "red");
                } else {
                    $("#jiraUsernameInput").css("border-color", "transparent");
                }
                if (this.password == undefined || this.password == null || this.password == "") {
                    response = false;
                    $("#jiraPasswordInput").css("border-color", "red");
                } else {
                    $("#jiraPasswordInput").css("border-color", "transparent");
                }
                if (this.project_name == undefined || this.project_name == null || this.project_name == "") {
                    response = false;
                    $("#jiraProjectInput").css("border-color", "red");
                } else {
                    $("#jiraProjectInput").css("border-color", "transparent");
                }
                if (this.issue_type == undefined || this.issue_type == null || this.issue_type == "") {
                    response = false;
                    $("#jiraIssueInput").css("border-color", "red");
                } else {
                    $("#jiraIssueInput").css("border-color", "transparent");
                }
                if (this.summary == undefined || this.summary == null || this.summary == "") {
                    response = false;
                    $("#jiraSummaryInput").css("border-color", "red");
                } else {
                    $("#jiraSummaryInput").css("border-color", "transparent");
                }

                return response;
            },
            testBtnClicked() {
                if (this.checkJiraTestParams()) {
                    this.jira_test_response = '';
                    var body = {
                        id: this.jira_id,
                        url: this.url,
                        username: this.username,
                        password: this.password,
                    }
                    if (this.findElementIndexInTableData() > -1) {
                        body.password_changed = this.$refs.jiraDatatable.tableData[this.findElementIndexInTableData()].password_changed
                    } else {
                        body.password_changed = false;
                    }
                    this.loading = true;
                    this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/notifications/jira/test', body)
                        .then(response => {
                            this.loading = false;
                            this.jiraConnectionSuccess = true;
                            $("#jiraTestResponseLabel").css("color", "limegreen");
                            this.jira_test_response = 'Connection tested successfully.';
                        }, response => {
                            this.loading = false;
                            this.jiraConnectionSuccess = false;
                            $("#jiraTestResponseLabel").css("color", "red");
                            this.jira_test_response = 'Connection error, please try again.';
                        })
                } else {
                    $("#jiraTestResponseLabel").css("color", "red");
                    this.jira_test_response = 'Please fill the fields required to test connection.';
                }
            },
            newBtnClicked() {
                this.url = null;
                this.username = null;
                this.password = null;
                this.project_name = null;
                this.issue_type = null;
                this.summary = null;
                this.priority = null;
                this.component = null;
                this.assignee = null;
                this.labels = null;
                this.jiraConnectionSuccess = false;
                this.jira_id = '';
                this.jira_pre_id = '';
                this.jira_test_response = '';
                $('#addJiraBtn').text('ADD');
                this.changeJiraParams();
            },
            addBtnClicked() {
                if (this.checkJiraAddParams()) {
                    this.jira_test_response = '';
                    if ($('#addJiraBtn').text().trim() == 'ADD') {
                        this.$refs.jiraDatatable.tableData.push(this.createJiraObject()).draw;
                    } else {
                        var index = null;
                        if (this.jira_id != '') {
                            index = this.$refs.jiraDatatable.tableData.findIndex(x => x.id == this.jira_id);
                        } else {
                            index = this.$refs.jiraDatatable.tableData.findIndex(x => x.pre_id == this.jira_pre_id);
                        }
                        if (index != null && index > -1) {
                            this.editJiraObject(index);
                        }
                    }
                    this.newBtnClicked();
                } else {
                    $("#jiraTestResponseLabel").css("color", "red");
                    this.jira_test_response = 'Please fill the fields required to add Jira notification.';
                }
            },
            editJiraObject(index) {
                var tableData = this.$refs.jiraDatatable.tableData;
                tableData[index].url = this.url;
                tableData[index].username = this.username;
                tableData[index].password = this.password;
                tableData[index].project_name = this.project_name;
                tableData[index].issue_type = this.issue_type;
                tableData[index].summary = this.summary;
                tableData[index].priority = this.priority;
                tableData[index].component = this.component;
                tableData[index].assignee = this.assignee;
                tableData[index].labels = this.labels;
                tableData[index].description = this.description;
                this.$refs.jiraDatatable.tableData = tableData;
            },
            createJiraObject() {
                return {
                    "pre_id": Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
                    "id": null,
                    "notification_id": null,
                    "url": this.url,
                    "username": this.username,
                    "password": this.password,
                    "project_name": this.project_name,
                    "issue_type": this.issue_type,
                    "summary": this.summary,
                    "priority": this.priority,
                    "component": this.component,
                    "assignee": this.assignee,
                    "labels": this.labels,
                    "description": this.description,
                    "password_changed": false
                }
            },
            onJiraEditClick(row) {
                this.edited_jira_notification_cat_logger_data_url = row.url;
                this.edited_jira_notification_cat_logger_data_username = row.username;
                this.edited_jira_notification_cat_logger_data_threat_type = row.summary;
                this.jiraConnectionSuccess = true;
                this.url = row.url != "None" ? row.url : "";
                this.username = row.username != "None" ? row.username : "";
                if (row.id != null) {
                    this.password = DEFAULT_PASSWORD;
                } else {
                    this.password = row.password != "None" ? row.password : "";
                }
                this.project_name = row.project_name != "None" ? row.project_name : "";
                this.issue_type = row.issue_type != "None" ? row.issue_type : "";
                this.summary = row.summary != "None" ? row.summary : "";
                this.priority = row.priority != "None" ? row.priority : "";
                this.component = row.component != "None" ? row.component : "";
                this.assignee = row.assignee != "None" ? row.assignee : "";
                this.labels = row.labels != "None" ? row.labels : "";
                this.description = row.description != "None" ? row.description : "";
                if (row.id != null) {
                    this.jira_id = row.id;
                    this.jira_pre_id = '';
                } else {
                    this.jira_pre_id = row.pre_id;
                    this.jira_id = '';
                }
                $('#addJiraBtn').text('UPDATE');
            },
            onJiraDeleteClick(row) {
                this.deleteRequestData = {
                    "id": row.id,
                    "pre_id": row.pre_id
                };
                this.$refs.confirmPopupModal.showModal('Are you sure to delete JIRA notification?');
            },
            popUpConfirmClicked() {
                this.$refs.confirmPopupModal.hideModal();
                if (this.deleteRequestData.id == null) {
                    var index = this.$refs.jiraDatatable.tableData.findIndex(x => x.pre_id == this.deleteRequestData.pre_id);
                    if (index != -1) {
                        this.$refs.jiraDatatable.tableData.splice(index, 1);
                    }
                } else {
                    let send_data = {
                        id: this.deleteRequestData.id
                    };
                    this.loading = true;
                    let promise = self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + NOTIFICATION_JIRA_DELETE_POST, send_data);
                    promise.then(function (response) {
                        this.loading = false;
                        var index = self.$refs.jiraDatatable.tableData.findIndex(x => x.id == this.deleteRequestData.id);
                        if (index != -1) {
                            self.$refs.jiraDatatable.tableData.splice(index, 1);
                        }
                    }, function () {
                        this.loading = false;
                        // console.log("Error occurred when saving new notification");
                    });
                }
            },
            findElementIndexInTableData() {
                var index = null;
                if (this.jira_id != '') {
                    index = this.$refs.jiraDatatable.tableData.findIndex(x => x.id == this.jira_id);
                } else {
                    index = this.$refs.jiraDatatable.tableData.findIndex(x => x.pre_id == this.jira_pre_id);
                }
                return index;
            }

        },
        computed: {
            jiraColumns() {
                return [
                    {
                        column: "project_name",
                        title: "PROJECT NAME",
                        class: "col-60"
                    },
                    {
                        column: "editDeleteRow",
                        title: "ACTIONS",
                        class: "col-40"
                    }
                ]
            },
            jiraUrl() {
                return "";
            },
            orderBy() {
                return {
                    column: "project_name",
                    ascending: false
                }
            },
            blur() {
                return {
                    isBlurred: this.loading,
                    opacity: 0.3,
                    filter: 'blur(4px)',
                    transition: 'all .5s linear'
                }
            },
            dataPath() {
                return 'data';
            },
            ...mapGetters([
                "getEnterpriseId",
                "getEnterpriseName"
            ])
        },
        mounted() {

        }
    }
</script>

<style scoped>

    #newJiraBtn {
        background-color: rgba(0, 255, 169, 1);
    }

    #testJiraBtn {
        background-color: #2196F3;
    }

    h4 {
        font-family: Digital-Serial-Bold;
    }

    .modal {
        text-align: center;
    }

    @media screen and (max-width: 768px) {
        .modal-dialog {
            width: 100%;
        }
    }

    .modal-dialog {
        display: inline-block;
        margin-top: 100px;
        background-color: rgba(0, 0, 0, 0.8);
        border: 1px solid rgba(30, 42, 53, 1);
        padding: 20px;
        min-width: 30vw;
        min-height: 30vw;
    }

    .modal-dialog-jira .row {
        height: 80vh;
        overflow-y: auto;
        overflow-x: hidden;
    }

    h4 {
        color: white;
    }

    .select-box {
        font-family: Digital-Serial-Bold;
        overflow: auto;
        width: 115%;
        height: 300px;
        border: 1px solid rgba(30, 42, 53, 1);
        background-color: black;
        color: white;
        padding: 5px;
        border-radius: 0px;
    }

    .select-box.sl-small {
        width: 100%;
        height: 50px;
        padding: 1px;
    }

    .select-box option {
        font-weight: bold;
    }

    .select-button {
        font-family: Digital-Serial-Regular;
        font-weight: bold;
        font-size: 49px;
        line-height: 40px;
        background: none;
        border: none;
        color: rgba(0, 255, 169, 1);
        background-color: transparent;
        width: 100%;
    }

    .notification-action-button {
        position: inherit;
    }

    .notification-action-button:disabled {
        background-color: gray;
        cursor: not-allowed;
    }

    .select-div {
        color: white;
        font-size: 16px;
        line-height: 30px;
        width: 100%;
    }

    .modal-lg {
        width: 1270px;
    }

    .jira-label {
        font-family: Digital-Serial-Regular;
        font-weight: bold;
        color: white;
        width: 17%;
    }

    .jira-input {
        font-family: Digital-Serial-Regular;
        font-weight: bold;
        color: black;
        width: 83%;
        float: right;
    }

    .jira-input input,
    .jira-input textarea {
        width: 96%;
        padding-left: 5px;
    }

    .jira-row-container {
        margin-bottom: 2%;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/EditNotificationSettings.vue